import { createSelector } from 'reselect'

export const stateSelector = state =>
  state.api.get.all.presenter_recommendations

export const data = () =>
  createSelector(
    [stateSelector],
    state => state.data
  )

export const isLoading = () =>
  createSelector(
    [stateSelector],
    state => state.isLoading
  )
